import { Select, styled } from '@mui/material';

export const StyledSortByWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  minWidth: 0,

  [theme.breakpoints.up('sm')]: {
    minWidth: '325px',
  },

  '& > h5:first-of-type': {
    marginLeft: '0.5rem',
    marginRight: '0.25rem',
  },
}));

export const StyledSortSelect = styled(Select)(({ theme }) => ({
  '.MuiOutlinedInput-input': {
    padding: '0.375rem',
  },

  '.MuiOutlinedInput-notchedOutline': {
    border: 0,
  },

  '& > svg:first-of-type': {
    color: theme.palette.common.black,
  },
}));
